import { render, staticRenderFns } from "./forum2.vue?vue&type=template&id=289aeb9c&scoped=true&"
import script from "./forum2.vue?vue&type=script&lang=js&"
export * from "./forum2.vue?vue&type=script&lang=js&"
import style0 from "./forum2.vue?vue&type=style&index=0&id=289aeb9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289aeb9c",
  null
  
)

export default component.exports